import React from 'react'

const CategorySettingScreen = () => {
    return (
        <div>CategorySettingScreen</div>
    )
}

export default CategorySettingScreen